import React, { Component } from "react";
import RolesManagementTableBodyTr from "./roles-management-table-body-tr";
import ReactPaginate from "react-paginate";

class RolesManagementTableBody extends Component {
  render() {
    const { alterarPerfilUsuario, removerUsuario, listaUsuarios, inativarUsuario, isInativar, papeis } = this.props;
    return (
      <tbody>
        {listaUsuarios.map((item, index) => {
          let papel = [];
          let perfil = "";
          if (papeis?.length) {
            const idPerfil = item?.id_perfil;

            perfil = papeis?.find(item => item.id === idPerfil);
            if (perfil) {
              const categoria = perfil.categoria;

              papel = papeis
                .filter(item => item.categoria === categoria)
                .map(item => ({
                  label: item.nome,
                  value: item.id,
                }));
            }
          }
                    

          return (
            <RolesManagementTableBodyTr
              papeis={papel}
              id={item.id}
              nome={item.nome + " " + item.sobrenome}
              email={item.email}
              perfil={perfil?.id}
              cnpj={item.cnpj}
              inativo={item.inativo}
              erro={item.erro}
              userLogado={item.userLogado}
              cpf={item.cpf}
              removerUsuario={removerUsuario}
              alterarPerfilUsuario={alterarPerfilUsuario}
              inativarUsuario={inativarUsuario}
              isInativar={isInativar}
            />
          );
        })}
      </tbody>
    );
  }
}

export default RolesManagementTableBody;
